import { createTestOverviewTypes } from '../../common/test-overview/types';

export const NAMESPACE = 'analytics-test-overview-vdc';
export default createTestOverviewTypes(NAMESPACE);
